import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { motion } from 'framer-motion';

export const FloatingButton = () => {
  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, duration: 0.3, type: 'spring' }}
      className="fixed bottom-6 right-6 z-50"
      data-testid="floating-request-btn"
    >
      <Link
        to="/employers#request-form"
        className="fab pulse-ring relative group"
        aria-label="Request Staff"
      >
        <Users size={24} strokeWidth={1.5} />
        <span className="absolute right-full mr-3 bg-[#0B1F3A] text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Request Staff
        </span>
      </Link>
    </motion.div>
  );
};
